export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_SHOP_BARBERS_SUCCESS = 'FETCH_SHOP_BARBERS_SUCCESS';
export const FETCH_SUBSCRIPTION_PLANS = 'FETCH_SUBSCRIPTION_PLANS';
